import React from 'react';
import styles from '../TemplatesFormChange.module.scss';
import { Button, Form, Input, message, Tooltip } from 'antd';
import BtnRegistration from '../../../common/BtnRegistration/BtnRegistration';
import { useCreateTemplates } from '../../HouseRegistrationTypeManager/api/createTemplates';
import { useSelector } from 'react-redux';
import { useChengeTemplates } from '../../HouseRegistrationTypeManager/api/chengeTempaltes';
import { registrationTypes } from '../../../../constants/registrationTypes';
import { formatMessage } from './utils/formatMessage';
import { modeList } from '../../../../constants/modeList';

const { Item } = Form;
const { TextArea } = Input;

const MSG_MAX_LENGTH_HEADING = 150;
const MSG_MAX_LENGTH_TEXT = 1500;
const MSG_MAX_LENGTH_NAME = 45;

const FormChangeNode = ({
  form,
  blocks,
  setBlocks,
  activeBlock,
  registrationTypeHouse,
  switchBlock,
  templateModem,
  changeForm,
  stateForm,
  changeTemlateModem,
  selectedTemlates,
  setSelectedTemlates,
}) => {
  const { getFieldDecorator, getFieldError, getFieldValue, validateFields } =
    form;
  const { createAsync, loading: createLoading } = useCreateTemplates();
  const { chengeAsync, loading: chengeLoading } = useChengeTemplates();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const isClosedType = registrationTypeHouse.id === registrationTypes.closed.id;
  const isPersonalAccountType =
    registrationTypeHouse.id === registrationTypes.personalAccounts.id;

  const createTemplates = async (e) => {
    e.preventDefault();

    validateFields(async (err, values) => {
      if (err) {
        message.error(
          'Пожалуйста, заполните все обязательные поля у двух блоков',
          2
        );
        return;
      }

      if (isPersonalAccountType) {
        const block1 = {
          title: values.title,
          message: values.message_block1,
          phone: values.phone_block1,
          url: values.url_block1,
          email: values.email_block1,
          address: values.address_block1,
        };

        const block2 = {
          message: values.message_block2,
          phone: values.phone_block2,
          url: values.url_block2,
          email: values.email_block2,
          address: values.address_block2,
        };

        const formattedMessage1 = formatMessage(block1);
        const formattedMessage2 = formatMessage(block2);

        const payload = {
          name: values.name,
          message: formattedMessage1,
          message2: formattedMessage2,
          serviceCompanyId: currentCompany?.id,
          registrationTypeId: registrationTypeHouse?.id,
        };

        if (templateModem === modeList.CHENGE_MODE) {
          await chengeAsync({
            ...payload,
            templateId: selectedTemlates?.id,
          });
        } else {
          await createAsync(payload);
        }
      } else {
        const stateForm = {
          title: values.title,
          message: values.message_stateForm,
          phone: values.phone_stateForm,
          url: values.url_stateForm,
          email: values.email_stateForm,
          address: values.address_stateForm,
        };
        const formattedMessage = formatMessage(stateForm);

        const payload = {
          name: values.name,
          message: formattedMessage,
          serviceCompanyId: currentCompany?.id,
          registrationTypeId: registrationTypeHouse?.id,
        };

        if (templateModem === modeList.CHENGE_MODE) {
          await chengeAsync({
            ...payload,
            templateId: selectedTemlates?.id,
          });
        } else {
          await createAsync(payload);
        }
      }

      changeTemlateModem(modeList.NOTHING_MODE);
      setSelectedTemlates(null);
    });
  };

  const cancelButton = () => {
    changeTemlateModem(modeList.NOTHING_MODE);
    setSelectedTemlates(null);
  };

  const renderBlockFields = (blockName, data) => (
    <>
      <Item
        label="Текст сообщения"
        style={{ marginBottom: 0 }}
        help={
          getFieldError(`message_${blockName}`) ||
          `${
            getFieldValue(`message_${blockName}`)?.length || 0
          }/${MSG_MAX_LENGTH_TEXT}`
        }
      >
        {getFieldDecorator(`message_${blockName}`, {
          initialValue: data.message,
          rules: [
            { required: true, message: 'Введите текст сообщения' },
            {
              max: MSG_MAX_LENGTH_TEXT,
              message: `Максимум ${MSG_MAX_LENGTH_TEXT} символов`,
            },
          ],
        })(
          <TextArea
            rows={4}
            name={`message_${blockName}`}
            placeholder="Введите текст"
            onChange={(e) =>
              changeForm({ target: { name: 'message', value: e.target.value } })
            }
            maxLength={MSG_MAX_LENGTH_TEXT}
          />
        )}
      </Item>

      <Item
        label="Телефон"
        style={{ marginBottom: 0 }}
      >
        {getFieldDecorator(`phone_${blockName}`, {
          initialValue: data.phone,
          rules: [
            { pattern: /^[0-9]+$/, message: 'Только цифры' },
            { len: 10, message: '10 цифр' },
          ],
        })(
          <Input
            addonBefore="+7"
            name={`phone_${blockName}`}
            placeholder="Введите телефон"
            maxLength={10}
            onChange={(e) =>
              changeForm({ target: { name: 'phone', value: e.target.value } })
            }
          />
        )}
      </Item>

      <Item
        label="Сайт"
        style={{ marginBottom: 0 }}
      >
        {getFieldDecorator(`url_${blockName}`, {
          initialValue: data.url,
          rules: [{ type: 'url', message: 'Введите корректный URL' }],
        })(
          <Input
            name={`url_${blockName}`}
            placeholder="https://example.com"
            onChange={(e) =>
              changeForm({ target: { name: 'url', value: e.target.value } })
            }
          />
        )}
      </Item>

      <Item
        label="Email"
        style={{ marginBottom: 0 }}
      >
        {getFieldDecorator(`email_${blockName}`, {
          initialValue: data.email,
          rules: [{ type: 'email', message: 'Некорректный email' }],
        })(
          <Input
            name={`email_${blockName}`}
            placeholder="support@example.com"
            onChange={(e) =>
              changeForm({ target: { name: 'email', value: e.target.value } })
            }
          />
        )}
      </Item>

      <Item
        label="Адрес"
        style={{ marginBottom: 0 }}
      >
        {getFieldDecorator(`address_${blockName}`, {
          initialValue: data.address,
        })(
          <Input
            name={`address_${blockName}`}
            placeholder="Введите адрес"
            onChange={(e) =>
              changeForm({ target: { name: 'address', value: e.target.value } })
            }
          />
        )}
      </Item>
    </>
  );

  return (
    <div className={styles.conteiner}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          {templateModem === modeList.CHENGE_MODE ? 'Изменение' : 'Создание'}
        </h3>
        <div className={styles.btnGroup}>
          <BtnRegistration
            text="Отмена"
            title="Отменить"
            onClick={cancelButton}
          />
          <Tooltip title="Сохранить шаблон">
            <Button
              style={{
                color: 'white',
                fontFamily: 'Segoe UI',
                fontSize: '12px',
                fontWeight: '500',
                borderRadius: '8px',
                backgroundColor: '#0995ED',
              }}
              type="primary"
              loading={createLoading || chengeLoading}
              onClick={createTemplates}
            >
              Сохранить
            </Button>
          </Tooltip>
        </div>
      </div>
      <Form className={styles.form}>
        <Item
          label="Наименование (не отображается у получателя)"
          style={{ marginBottom: 0 }}
          help={
            getFieldError('name') ||
            `${getFieldValue('name')?.length || 0}/${MSG_MAX_LENGTH_NAME}`
          }
        >
          {getFieldDecorator('name', {
            initialValue: selectedTemlates ? selectedTemlates.name : '',
            rules: [
              { required: true, message: 'Пожалуйста, введите наименование' },
              {
                max: MSG_MAX_LENGTH_NAME,
                message: `Длинна текста не должна превышать ${MSG_MAX_LENGTH_NAME} символов`,
              },
            ],
          })(
            <Input
              placeholder="Введите наименование"
              name="name"
              maxLength={MSG_MAX_LENGTH_NAME}
            />
          )}
        </Item>
        <Item
          label="Заголовок"
          style={{ marginBottom: 0 }}
          help={
            getFieldError('title') ||
            `${
              (isPersonalAccountType
                ? blocks.block1.title.length
                : stateForm.title.length) || 0
            }/${MSG_MAX_LENGTH_HEADING}`
          }
        >
          {getFieldDecorator('title', {
            initialValue: isPersonalAccountType
              ? blocks.block1.title
              : stateForm.title,
            rules: [
              { required: true, message: 'Пожалуйста, введите заголовок' },
              {
                max: MSG_MAX_LENGTH_HEADING,
                message: `Длинна текста не должна превышать ${MSG_MAX_LENGTH_HEADING} символов`,
              },
            ],
          })(
            <Input
              name="title"
              placeholder="Введите заголовок"
              onChange={(e) => {
                const { value } = e.target;

                if (isClosedType) {
                  changeForm({ target: { name: 'title', value } });
                } else if (isPersonalAccountType) {
                  setBlocks((prev) => ({
                    ...prev,
                    block1: {
                      ...prev.block1,
                      title: value,
                    },
                  }));
                }
              }}
              maxLength={MSG_MAX_LENGTH_HEADING}
            />
          )}
        </Item>
        {isPersonalAccountType ? (
          <>
            <div className={styles.blockSwitcher}>
              <Button
                type="link"
                className={`${styles.switchButton} ${
                  activeBlock === 'block1' ? styles.active : ''
                }`}
                onClick={() => switchBlock('block1')}
              >
                1 блок
              </Button>
              <Button
                type="link"
                className={`${styles.switchButton} ${
                  activeBlock === 'block2' ? styles.active : ''
                }`}
                onClick={() => switchBlock('block2')}
              >
                3 блок
              </Button>
            </div>
            <div
              style={{ display: activeBlock === 'block1' ? 'block' : 'none' }}
            >
              {renderBlockFields('block1', blocks.block1)}
            </div>

            <div
              style={{ display: activeBlock === 'block2' ? 'block' : 'none' }}
            >
              {renderBlockFields('block2', blocks.block2)}
            </div>
          </>
        ) : (
          <div>{renderBlockFields('stateForm', stateForm)}</div>
        )}
      </Form>
    </div>
  );
};

const FormChange = Form.create({ name: 'change_editor_link' })(FormChangeNode);

export default FormChange;
